import { ReactElement } from "react";
import { IPieConfig } from "../../../components/charts/types";
import CardBase from "../../../components/widgets/cardBase";
import { IDetailProps } from "../../../types";
import PieChart from "../../../components/charts/pieChart";

interface IComponentCProps {
  pieConfig: IPieConfig;
  title: string;
  detail: IDetailProps | undefined | null;
}

const ComponentC = ({ title, pieConfig, detail }: IComponentCProps): ReactElement => {
  return (
    <CardBase title={title} detail={detail}>
      <PieChart pieConfig={pieConfig}/>
    </CardBase>
  );
};

export default ComponentC;
